import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";

class AccountsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      medicines: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" }
    };
  }

  componentDidMount() {
    this.showBusy(true);
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/medicine"
      )
      .then(response => {
        this.setState({ medicines: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
    this.showBusy(false);
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Medicine List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
                name="Income"
              >
                Add Medicine
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit Medicine
              </button>
            </div>
            <AgGridReact
              rowData={this.state.medicines}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                field="mno"
                headerName="Medicine #"
                width={120}
                checkboxSelection
                //filter={false}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="name"
                headerName="Name"
                width={150}
                sortable
                resizable
                filter
              />

              <AgGridColumn
                field="qty"
                headerName="Stock"
                width={120}
                sortable
                resizable
                filter
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "", dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse", dataClass: "" });
    }
  }

  currencyFormatter(params) {
    var parts = params.value.toString().split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : "")
    );
  }

  dateFormatter(params) {
    if (params.value !== null) {
      var arr = new Date(params.value).toDateString().split(" ");
      return arr[2] + "-" + arr[1] + "-" + arr[3];
    }
  }

  onAddClick = e => {
    //alert(e.target.name);
    this.props.onClick("Add", this.state.dummy);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("Edit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Medicine !!"
      });
    }
  };
}

export default AccountsList;
